import {
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

// Bestätigungsdialog für Service-Worker-/Benachrichtigungs-/Cache-Aktionen.
function ConfirmDialog({ open, type, onClose, onConfirm }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableEnforceFocus disableRestoreFocus>
            <DialogTitle sx={{ bgcolor: '#1f2937', color: '#e0f2fe' }}>
                {type === 'enable' && 'Service Worker aktivieren?'}
                {type === 'disable' && 'Service Worker deaktivieren?'}
                {type === 'clearCache' && 'Cache wirklich leeren?'}
                {type === 'notifications' && 'Benachrichtigungen aktivieren?'}
                {type === 'pushSubscribe' && 'Push-Benachrichtigungen aktivieren?'}
                {type === 'pushUnsubscribe' && 'Push-Benachrichtigungen deaktivieren?'}
            </DialogTitle>
            <DialogContent sx={{ bgcolor: '#1f2937' }}>
                <Typography sx={{ color: '#93c5fd', mt: 1 }}>
                    {type === 'enable' && 'Dies ermöglicht Offline-Unterstützung und schnellere Ladezeiten.'}
                    {type === 'disable' && 'Die App funktioniert weiterhin, hat aber keine Offline-Unterstützung.'}
                    {type === 'clearCache' && 'Der gecachte Speicher wird gelöscht. Dies kann nicht rückgängig gemacht werden.'}
                    {type === 'notifications' && 'Du erhältst Benachrichtigungen über wichtige Ereignisse.'}
                    {type === 'pushSubscribe' && 'Du erhältst Push-Benachrichtigungen über Gruppeneinladungen, Termine und wichtige Updates.'}
                    {type === 'pushUnsubscribe' && 'Du erhältst keine Push-Benachrichtigungen mehr. Du kannst sie jederzeit wieder aktivieren.'}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ bgcolor: '#1f2937' }}>
                <Button onClick={onClose} sx={{ color: '#93c5fd' }}>Abbrechen</Button>
                <Button onClick={onConfirm} variant="contained" sx={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)', color: '#fff', borderRadius: '16px' }}>Bestätigen</Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
